// Need to use the React-specific entry point to import createApi
import { getToken } from "./localStorageService";
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage 

// Define a service using a base URL and expected endpoints
export const userApi =  baseApi.injectEndpoints({
  credentials: "include",
  // tagTypes: ['User'],
  // global configuration for the api
  // refetchOnFocus: true,
  endpoints: (builder) => ({
    changeUserPassword: builder.mutation({
      query: ({updatedData, id}) => {
        return {
          url: `change-user-password/${id}`,
          method: "POST",
          body: updatedData,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            // authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    blockUser: builder.mutation({
      query: ({id}) => {
        return {
          url: `block-user/${id}`,
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            },
        };
      },
    }),
    unBlockUser: builder.mutation({
      query: ({id}) => {
        return {
          url: `unblock-user/${id}`,
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useChangeUserPasswordMutation,
  useBlockUserMutation,
  useUnBlockUserMutation,

} = userApi;
